export const blogPosts = [
    {
        id: 16,
        title: 'TSE-Pflicht 2026 für Bolt-Fahrer',
        slug: 'tse-pflicht-2026-bolt-fahrer',
        description:
            'Als Bolt-Fahrer in Deutschland arbeiten Sie als Mietwagenunternehmer – und das bedeutet: Ab dem 1. Januar 2026 gilt auch für Sie die TSE-Pflicht. Viele Bolt-Fahrer sind sich dessen noch nicht bewusst, doch die Deadline rückt näher. Wer bis dahin nicht TSE-konform ist, riskiert Bußgelder bis zu 25.000 € und den Verlust der Mietwagengenehmigung.',
        author: 'TaxiFusion Team',
        date: '2025-12-19',
        category: 'Sicherheit & Compliance',
        tags: [
            'tse',
            'bolt',
            'mietwagen',
            'mietwagenunternehmen',
            'compliance',
            '2026',
            'tse-pflicht',
            'umrüstung',
            'wegstreckenzähler',
            'taxameter',
            'festpreise',
            'app-basierte-abrechnung',
            'flotten-fahrzeuge',
            'taxifusion',
        ],
        featured: false,
        readingTime: 15,
        image: '/blog/tse-pflicht-2026-bolt-fahrer/images/featured.jpg',
        contentFile: '/blog/tse-pflicht-2026-bolt-fahrer/index.md',
    },
    {
        id: 15,
        title: 'TSE-Pflicht 2026: Was Krankenfahrt-Unternehmen jetzt wissen müssen',
        slug: 'tse-pflicht-krankenfahrten-2026',
        description:
            'Ab dem 1. Januar 2026 gilt die TSE-Pflicht auch für Krankenfahrt-Unternehmen – ohne Ausnahmen. Viele Betriebe sind unsicher: Gilt die Pflicht auch für Krankenfahrten? Müssen Festpreise erfasst werden? Was passiert bei Verstößen? Dieser Leitfaden gibt Antworten – praxisnah, verständlich und mit konkreten Handlungsempfehlungen.',
        author: 'TaxiFusion Team',
        date: '2025-11-26',
        category: 'Sicherheit & Compliance',
        tags: [
            'tse',
            'krankenfahrten',
            'krankenfahrt-unternehmen',
            'taxiunternehmen',
            'mietwagenunternehmen',
            'compliance',
            '2026',
            'umrüstung',
            'tse-pflicht',
            'taxifusion',
        ],
        featured: false,
        readingTime: 12,
        image: '/blog/tse-pflicht-krankenfahrten-2026/images/featured.png',
        contentFile: '/blog/tse-pflicht-krankenfahrten-2026/index.md',
    },
    {
        id: 14,
        title: 'TSE-Pflicht 2026 in Frankfurt: Der Leitfaden für Taxi- und Mietwagenunternehmen',
        slug: 'tse-pflicht-2026-frankfurt-taxi-mietwagenunternehmen',
        description:
            'Ab 01.01.2026 gilt die TSE-Pflicht auch in Frankfurt. Was Frankfurter Taxi- und Mietwagenunternehmen jetzt wissen müssen und wie sie mit TaxiFusion gesetzeskonform werden und gleichzeitig ihre operativen Herausforderungen lösen.',
        author: 'TaxiFusion Team',
        date: '2025-11-08',
        category: 'Sicherheit & Compliance',
        tags: [
            'tse',
            'frankfurt',
            'taxiunternehmen',
            'mietwagenunternehmen',
            'compliance',
            '2026',
            'umrüstung',
            'flughafen frankfurt',
            'messe frankfurt',
            'business-kunden',
            'taxifusion',
        ],
        featured: false,
        readingTime: 13,
        image: '/blog/tse-pflicht-2026-frankfurt-taxi-mietwagenunternehmen/images/featured.jpg',
        contentFile: '/blog/tse-pflicht-2026-frankfurt-taxi-mietwagenunternehmen/index.md',
    },
    {
        id: 1,
        title: 'TaxiFusion: Die kritische TSE-Compliance-Lösung',
        slug: 'taxifusion-tse-compliance-loesung-2026',
        description:
            'TaxiFusion ist die spezialisierte Softwareplattform für TSE-Compliance ab 2026. Erfahren Sie, wie TaxiFusion als TSE-Datenspeicher- und Managementlösung funktioniert und warum es für Ihr Taxiunternehmen unverzichtbar ist.',
        author: 'TaxiFusion Team',
        date: '2025-08-20',
        category: 'Sicherheit & Compliance',
        tags: [
            'taxifusion',
            'tse',
            'compliance',
            'software',
            '2026',
            'datenspeicherung',
            'hale',
            'semitron',
            'digitax',
        ],
        featured: true,
        readingTime: 4,
        image: '/blog/taxifusion-tse-compliance-loesung-2026/images/featured.jpg',
        contentFile: '/blog/taxifusion-tse-compliance-loesung-2026/index.md',
    },
    {
        id: 2,
        title: 'TSE-Pflicht ab 2026: Wichtige Infos für Taxiunternehmer in Deutschland',
        slug: 'tse-pflicht-ab-2026-taxiunternehmer-deutschland',
        description:
            'Ab dem 1. Januar 2026 gilt in Deutschland eine neue Pflicht für alle Taxi- und Mietwagenunternehmen: die Technische Sicherheitseinrichtung (TSE) wird verbindlich vorgeschrieben. Erfahren Sie alles über Fristen, Konsequenzen und Lösungen.',
        author: 'TaxiFusion Team',
        date: '2025-07-15',
        category: 'Sicherheit & Compliance',
        tags: ['tse', 'compliance', 'steuer', 'kassensystem', '2026', 'gesetz'],
        featured: false,
        readingTime: 10,
        image: '/blog/tse-pflicht-ab-2026-taxiunternehmer-deutschland/images/featured.jpg',
        contentFile: '/blog/tse-pflicht-ab-2026-taxiunternehmer-deutschland/index.md',
    },
    {
        id: 3,
        title: 'TSE-Umrüstung 2026: Wichtige Informationen für Taxiunternehmen in Berlin',
        slug: 'tse-umruestung-2026-taxiunternehmen-berlin',
        description:
            'Berliner Taxiunternehmer stehen vor einer wichtigen Frist – ab dem 1. Januar 2026 dürfen Taxis bundesweit nur noch mit einer zertifizierten Technischen Sicherheitseinrichtung (TSE) im Taxameter betrieben werden. Praxisnahe Informationen für das Taxigewerbe in Berlin.',
        author: 'TaxiFusion Team',
        date: '2025-07-28',
        category: 'Sicherheit & Compliance',
        tags: [
            'tse',
            'berlin',
            'umrüstung',
            'compliance',
            'steuer',
            'kassensystem',
            '2026',
            'gesetz',
            'labo',
            'eichamt',
        ],
        featured: false,
        readingTime: 12,
        image: '/blog/tse-umruestung-2026-taxiunternehmen-berlin/images/featured.jpg',
        contentFile: '/blog/tse-umruestung-2026-taxiunternehmen-berlin/index.md',
    },
    {
        id: 4,
        title: 'TSE-Umrüstung für Münchner Taxiunternehmen: Praxisleitfaden bis 2026',
        slug: 'tse-umruestung-muenchner-taxiunternehmen-praxisleitfaden-2026',
        description:
            'Zum Jahreswechsel 2025/2026 steht für alle Taxiunternehmer eine wichtige Änderung an: Die Technische Sicherheitseinrichtung (TSE) wird ab 1. Januar 2026 bundesweit zur Pflicht – auch im Münchner Taxigewerbe. Praxisnahe Informationen für kleine und mittlere Taxiunternehmen.',
        author: 'TaxiFusion Team',
        date: '2025-08-12',
        category: 'Sicherheit & Compliance',
        tags: [
            'tse',
            'münchen',
            'umrüstung',
            'compliance',
            'steuer',
            'kassensystem',
            '2026',
            'gesetz',
            'bayerischer-verband',
            'taxi-münchen-eg',
            'bokraft',
        ],
        featured: false,
        readingTime: 13,
        image: '/blog/tse-umruestung-muenchner-taxiunternehmen-praxisleitfaden-2026/images/featured.jpg',
        contentFile: '/blog/tse-umruestung-muenchner-taxiunternehmen-praxisleitfaden-2026/index.md',
    },
    {
        id: 5,
        title: 'Stuttgart bereitet sich vor: TSE‑Technik im Taxi rechtzeitig integrieren',
        slug: 'stuttgart-bereitet-sich-vor-tse-technik-im-taxi-rechtzeitig-integrieren',
        description:
            'Ab 2026 sind nur noch Taxis mit zertifizierter TSE unterwegs – die rechtzeitige Integration der TSE-Technik ist für Taxiunternehmen in Stuttgart jetzt entscheidend. Erfahren Sie mehr über urbane Herausforderungen und technische Lösungen.',
        author: 'TaxiFusion Team',
        date: '2025-08-25',
        category: 'Sicherheit & Compliance',
        tags: [
            'tse',
            'stuttgart',
            'taxiunternehmen',
            'compliance',
            '2026',
            'umrüstung',
            'steuer',
            'kassensystem',
            'gesetz',
            'mobilfunk',
            'verkehr',
            'werkstatt',
            'taxifusion',
        ],
        featured: false,
        readingTime: 9,
        image: '/blog/stuttgart-bereitet-sich-vor-tse-technik-im-taxi-rechtzeitig-integrieren/images/featured.png',
        contentFile:
            '/blog/stuttgart-bereitet-sich-vor-tse-technik-im-taxi-rechtzeitig-integrieren/index.md',
    },
    {
        id: 6,
        title: 'TSE-Pflicht ab 2026: Was Mietwagenunternehmen und Uber-Fahrer wissen müssen',
        slug: 'tse-pflicht-ab-2026-mietwagenunternehmen-uber-fahrer',
        description:
            'Ab 1. Januar 2026 gilt in Deutschland eine flächendeckende TSE-Pflicht für Taxi- und Mietwagenbetriebe. Nach Jahren der Übergangsfristen müssen nun auch Unternehmen im Mietwagenverkehr mit Fahrer (gemäß PBefG) – hierzu zählen etwa Uber-Fahrer mit Mietwagenkonzession – ihre elektronischen Aufzeichnungssysteme mit einer Technischen Sicherheitseinrichtung (TSE) ausstatten.',
        author: 'TaxiFusion Team',
        date: '2025-08-27',
        category: 'Sicherheit & Compliance',
        tags: [
            'tse',
            'mietwagen',
            'uber',
            'compliance',
            'steuer',
            'kassensystem',
            '2026',
            'gesetz',
            'pbefg',
            'taxifusion',
        ],
        featured: false,
        readingTime: 14,
        image: '/blog/tse-pflicht-ab-2026-mietwagenunternehmen-uber-fahrer/images/featured.jpg',
        contentFile: '/blog/tse-pflicht-ab-2026-mietwagenunternehmen-uber-fahrer/index.md',
    },
    {
        id: 7,
        title: 'TSE-Pflicht 2026: Was Taxiunternehmen in Hannover jetzt wissen müssen',
        slug: 'tse-pflicht-2026-hannover-taxiunternehmen',
        description:
            'Taxiunternehmen in Hannover stehen vor bedeutenden Veränderungen: Ab dem 1. Januar 2026 gilt bundesweit die TSE-Pflicht für alle Taxis und Mietwagen. Erfahren Sie alles über die Umsetzung in Hannover, lokale Herausforderungen und digitale Lösungen für die Zukunft.',
        author: 'TaxiFusion Team',
        date: '2025-08-30',
        category: 'Sicherheit & Compliance',
        tags: [
            'tse',
            'hannover',
            'taxiunternehmen',
            'compliance',
            '2026',
            'umrüstung',
            'steuer',
            'kassensystem',
            'gesetz',
            'festpreise',
            'uber',
            'digitale-abrechnung',
            'taxifusion',
        ],
        featured: false,
        readingTime: 11,
        image: '/blog/tse-pflicht-2026-hannover-taxiunternehmen/images/featured.jpg',
        contentFile: '/blog/tse-pflicht-2026-hannover-taxiunternehmen/index.md',
    },
    {
        id: 8,
        title: 'TSE-Pflicht ab 2026 – Was bedeutet das für Hamburgs Taxiunternehmer?',
        slug: 'tse-pflicht-2026-hamburg-taxiunternehmen',
        description:
            'TSE-Pflicht ab 2026 – Was bedeutet das für Hamburgs Taxiunternehmer? Erfahren Sie alles über die Umsetzung der Technischen Sicherheitseinrichtung in Hamburg, lokale Herausforderungen, E-Mobilität und digitale Lösungen.',
        author: 'TaxiFusion Team',
        date: '2025-09-04',
        category: 'Sicherheit & Compliance',
        tags: [
            'tse',
            'hamburg',
            'taxiunternehmen',
            'compliance',
            '2026',
            'umrüstung',
            'e-taxis',
            'hale',
            'semitron',
            'fms',
            'elektrifizierung',
            'digitale-abrechnung',
            'taxifusion',
        ],
        featured: false,
        readingTime: 15,
        image: '/blog/tse-pflicht-2026-hamburg-taxiunternehmen/images/featured.jpg',
        contentFile: '/blog/tse-pflicht-2026-hamburg-taxiunternehmen/index.md',
    },
    {
        id: 9,
        title: 'Flottenmanagement für Taxiunternehmen: Effizienz steigern, Kosten senken',
        slug: 'flottenmanagement-taxi',
        description:
            'Taxiunternehmen mit mehreren Fahrzeugen stehen vor komplexen Herausforderungen im Flottenmanagement. Erfahren Sie, wie digitale Lösungen wie TaxiFusion helfen, Effizienz zu steigern und Kosten zu senken.',
        author: 'TaxiFusion Team',
        date: '2025-09-08',
        category: 'Flottenmanagement',
        tags: [
            'flottenmanagement',
            'taxiunternehmen',
            'mehrwagenbetriebe',
            'effizienz',
            'kostensenkung',
            'digitale-lösungen',
            'fahrer-management',
            'schichtplanung',
            'umsatzübersicht',
            'tse-konform',
            'taxifusion',
            'fahrzeugverwaltung',
            'wartungsmanagement',
        ],
        featured: false,
        readingTime: 8,
        image: '/blog/flottenmanagement-taxi/images/featured.jpg',
        contentFile: '/blog/flottenmanagement-taxi/index.md',
    },
    // {
    //     id: 10,
    //     title: 'Haben Sie ein HALE-Gerät? So werden Sie TSE-ready mit TaxiFusion',
    //     slug: 'hale-geraet-tse-ready-taxifusion',
    //     description:
    //         'Alle aktuellen HALE-Taxameter und Wegstreckenzähler sind mit TaxiFusion kompatibel und können die gesetzlich vorgeschriebene TSE-Datenspeicherung erfüllen. Erfahren Sie, welche HALE-Geräte TSE-fähig sind und welche Schritte Sie für die Umrüstung benötigen.',
    //     author: 'TaxiFusion Team',
    //     date: '2025-10-26',
    //     category: 'Sicherheit & Compliance',
    //     tags: [
    //         'hale',
    //         'tse',
    //         'compliance',
    //         'taxameter',
    //         'mct-07',
    //         'mct-06',
    //         'spt',
    //         'sei-03',
    //         'wsz-06',
    //         'umrüstung',
    //         '2026',
    //         'taxifusion',
    //         'hardware',
    //         'signierung',
    //         'datencenter',
    //     ],
    //     featured: false,
    //     readingTime: 12,
    //     image: '/blog/hale-geraet-tse-ready-taxifusion/images/featured.jpg',
    //     contentFile: '/blog/hale-geraet-tse-ready-taxifusion/index.md',
    // },
    // {
    //     id: 11,
    //     title: 'Haben Sie ein SEMITRON-Gerät? So werden Sie TSE-ready mit TaxiFusion',
    //     slug: 'semitron-geraet-tse-ready-taxifusion',
    //     description:
    //         'SEMITRON Panther-Modelle (P6L, P6S, P6C) werden mit einer externen Bluetooth‑TSE‑Box TSE‑konform. Erfahren Sie, wie die Implementierung funktioniert und welche Schritte zur Umrüstung nötig sind – mit zentraler Datenspeicherung in TaxiFusion.',
    //     author: 'TaxiFusion Team',
    //     date: '2025-10-29',
    //     category: 'Sicherheit & Compliance',
    //     tags: [
    //         'semitron',
    //         'panther',
    //         'p6l',
    //         'p6s',
    //         'p6c',
    //         'wegstreckenzaehler',
    //         'bluetooth',
    //         'tse',
    //         'compliance',
    //         '2026',
    //         'taxameter',
    //         'datenspeicherung',
    //         'taxifusion',
    //     ],
    //     featured: false,
    //     readingTime: 14,
    //     image: '/blog/semitron-geraet-tse-ready-taxifusion/images/featured.jpg',
    //     contentFile: '/blog/semitron-geraet-tse-ready-taxifusion/index.md',
    // },
    {
        id: 12,
        title: 'Flottenmanagement für Mietwagenunternehmen',
        slug: 'flottenmanagement-mietwagenunternehmen',
        description:
            'Viele Mietwagenunternehmen managen ihre Flotten noch traditionell mit Excel-Tabellen. Erfahren Sie, wie digitale Flottenmanagement-Software wie TaxiFusion hilft, Effizienz zu steigern und Kosten zu senken.',
        author: 'TaxiFusion Team',
        date: '2025-11-01',
        category: 'Flottenmanagement',
        tags: [
            'flottenmanagement',
            'mietwagenunternehmen',
            'flotte',
            'effizienz',
            'kostensenkung',
            'digitale-lösungen',
            'fahrzeugverwaltung',
            'live-tracking',
            'umsatzanalyse',
            'fleet-management',
            'rental-car',
            'taxifusion',
        ],
        featured: false,
        readingTime: 7,
        image: '/blog/flottenmanagement-mietwagenunternehmen/images/featured.jpg',
        contentFile: '/blog/flottenmanagement-mietwagenunternehmen/index.md',
    },
    {
        id: 13,
        title: 'TSE-Pflicht 2026: Was Kölner Taxiunternehmen jetzt wissen müssen',
        slug: 'tse-pflicht-2026-koeln-taxiunternehmen',
        description:
            'Ab 01.01.2026 gilt die TSE-Pflicht. Was Kölner Taxiunternehmen jetzt wissen und wie sie mit TaxiFusion gesetzeskonform und effizient werden.',
        author: 'TaxiFusion Team',
        date: '2025-11-02',
        category: 'Sicherheit & Compliance',
        tags: [
            'tse',
            'köln',
            'taxiunternehmen',
            'compliance',
            '2026',
            'umrüstung',
            'koelnmesse',
            'flughafen köln/bonn',
            'disposition',
            'taxifusion',
        ],
        featured: false,
        readingTime: 14,
        image: '/blog/tse-pflicht-2026-koeln-taxiunternehmen/images/featured.jpg',
        contentFile: '/blog/tse-pflicht-2026-koeln-taxiunternehmen/index.md',
    },
];

// Helper function to get post by slug
export const getPostBySlug = (slug) => {
    return blogPosts.find((post) => post.slug === slug);
};

// Helper function to get posts by category
export const getPostsByCategory = (category) => {
    return blogPosts.filter((post) => post.category === category);
};

// Helper function to get featured posts
export const getFeaturedPosts = () => {
    return blogPosts.filter((post) => post.featured);
};

// Helper function to get all categories
export const getAllCategories = () => {
    const categories = [...new Set(blogPosts.map((post) => post.category))];
    return categories.map((category) => ({
        name: category,
        count: blogPosts.filter((post) => post.category === category).length,
    }));
};

// Helper function to get all tags
export const getAllTags = () => {
    const allTags = blogPosts.flatMap((post) => post.tags);
    const uniqueTags = [...new Set(allTags)];
    return uniqueTags.map((tag) => ({
        name: tag,
        count: allTags.filter((t) => t === tag).length,
    }));
};
